<ng-progress
  ngProgressHttp
  globalProgressBar />
<notifications />
@if (showScroll$ | async) {
  <scroll-to-top (scrollToTop)="onScrollToTop()" />
}

@switch (layout$ | async) {
  @case (Layouts.DEFAULT_LAYOUT) {
    <default-layout />
  }
  @default {
    <div>
      <router-outlet />
    </div>
  }
}
